module.exports = __webpack_public_path__ + "static/media/stepper-invite-icon-active.92539b18.svg";